export default "__VITE_ASSET__BL60pL35__"